import type { ReactNode } from 'react'

import Link from 'next/link'

import { chakra } from '@hivewatch/dark'

import { getRuleHref } from '../utils/ruleRoutes'

interface RuleNameLinkIProps {
  children: ReactNode
  id: string
  isV2: boolean
}

// The row already navigates on click, so the link must not let its own
// click/auxclick reach the row: Cmd + click would otherwise open two tabs
// and a plain click would navigate twice. The link handles both itself.
const stopRowClick = (event: React.MouseEvent<HTMLAnchorElement>) =>
  event.stopPropagation()

/**
 * Rule name rendered as a real link so the browser's own link behaviour
 * works on it: right-click "Open in new tab", Cmd/Ctrl + click and the URL
 * preview on hover.
 */
export const RuleNameLink = ({ children, id, isV2 }: RuleNameLinkIProps) => (
  <chakra.a
    _hover={{ textDecoration: 'underline' }}
    asChild
    color='inherit'
    display='block'
    minWidth={0}
    textDecoration='none'
  >
    <Link
      data-testid='rulesPage_table_nameLink'
      href={getRuleHref(id, isV2)}
      onAuxClick={stopRowClick}
      onClick={stopRowClick}
    >
      {children}
    </Link>
  </chakra.a>
)
